// Shareable note snippet (item 5): plain-text copy + a downloadable image card.
// Minimal branding — wordmark only, no promotional text.

export function noteSnippetText(reference, note) {
  const ref = (reference || "").trim();
  const body = (note || "").trim();
  return `${ref}\n\n${body}\n\n— OpenWord AI`;
}

function wrapText(ctx, text, x, y, maxWidth, lineHeight, maxLines) {
  const words = (text || "").split(/\s+/);
  let line = "";
  let lines = 0;
  for (let i = 0; i < words.length; i++) {
    const test = line ? `${line} ${words[i]}` : words[i];
    if (ctx.measureText(test).width > maxWidth && line) {
      ctx.fillText(line, x, y);
      line = words[i];
      y += lineHeight;
      lines += 1;
      if (maxLines && lines >= maxLines - 1) {
        // last allowed line — dump the remainder (possibly truncated)
        let rest = words.slice(i).join(" ");
        while (ctx.measureText(`${rest}…`).width > maxWidth && rest.length > 0) {
          rest = rest.slice(0, -1);
        }
        ctx.fillText(rest.length < words.slice(i).join(" ").length ? `${rest}…` : rest, x, y);
        return y;
      }
    } else {
      line = test;
    }
  }
  if (line) ctx.fillText(line, x, y);
  return y;
}

export function downloadNoteImage(reference, note) {
  const W = 1080;
  const H = 1080;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Calm Desk background
  ctx.fillStyle = "#07090E";
  ctx.fillRect(0, 0, W, H);

  const M = 96;

  // Teal accent rule
  ctx.fillStyle = "#00E5FF";
  ctx.fillRect(M, 150, 72, 6);

  // Reference
  ctx.fillStyle = "#00E5FF";
  ctx.font = "600 40px Georgia, 'Times New Roman', serif";
  ctx.fillText((reference || "").trim(), M, 236);

  // Note body (serif, generous line height)
  ctx.fillStyle = "#161D2F";
  ctx.font = "italic 52px Georgia, 'Times New Roman', serif";
  wrapText(ctx, (note || "").trim(), M, 340, W - M * 2, 74, 8);

  // Wordmark
  ctx.fillStyle = "#3A4763";
  ctx.font = "500 32px Georgia, 'Times New Roman', serif";
  ctx.fillText("OpenWord AI", M, H - 96);

  const a = document.createElement("a");
  a.href = canvas.toDataURL("image/png");
  a.download = "openword-note.png";
  a.click();
}
